module.exports = __webpack_public_path__ + "static/leica-logo-23adc9d1c1e507d61c7a75bbc467b970.png";